import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=6e93dd77&scoped=true&"
import script from "./Mobile.vue?vue&type=script&lang=ts&"
export * from "./Mobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e93dd77",
  null
  
)

export default component.exports